var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 5H18V3H1v2h15.5zm.5 17.5v-16a.5.5 0 00-.5-.5h-14a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h14a.5.5 0 00.5-.5zM6.537 1C6.229 1 6 1.174 6 1.33V2h7v-.67c0-.156-.229-.33-.537-.33H6.537zM14 2h4a1 1 0 011 1v2a1 1 0 01-1 1h-.092c.056.157.092.324.092.5v16c0 .827-.673 1.5-1.5 1.5h-14c-.827 0-1.5-.673-1.5-1.5v-16c0-.176.036-.343.092-.5H1a1 1 0 01-1-1V3a1 1 0 011-1h4v-.67C5 .597 5.689 0 6.537 0h5.926C13.311 0 14 .597 14 1.33V2zM6 20.5a.5.5 0 01-1 0v-12a.5.5 0 011 0v12zm8 0a.5.5 0 01-1 0v-12a.5.5 0 011 0v12zm-4.5.5a.5.5 0 00.5-.5v-12a.5.5 0 00-1 0v12a.5.5 0 00.5.5z",
    fill: "#999"
  })));
}
SvgBin.displayName = 'Bin';
export default SvgBin;